import { Base } from '../../core/base.model';
import { Empleado } from '../../empleado/empleado.model';
import { Incidencias } from 'src/app/shared/model/incidencias/incidencia.model';
import { Version } from './version.model';


export class Etapa extends Base {
  id: string;
  idEtapa: number;
  idProyectoEtapa: string;
  idLiderEtapa: number;
  nombreLider: string;
  idLiderEtapaQA: number;
  nombreLiderQA: string;
  nombre: string;
  descripcion: string;
  fechaInicio: string;
  fechaFin: string;
  recursosAsignados: Empleado[];
  defectos: Incidencias[];
  versiones: Version[] = [];

}
